<template>
    <RouterLink v-if="to" :to="to" :class="classes">
        <slot/>
        {{ text }}
        <TranslateText :text="trans"/>
    </RouterLink>
    <a v-else :class="classes" :href="href" v-bind="$attrs">
        <slot/>
        {{ text }}
        <TranslateText :text="trans"/>
    </a>
</template>

<script setup>
import TranslateText from "@/components/TranslateText.vue";

const classes = 'text-sm font-medium leading-6 text-slate-500 hover:underline';

const props = defineProps({
    to: String,
    text: String,
    trans: String,
    href: String,
});
</script>
